import createShopWhatsappAccount from "../../api/createShopWhatsappAccount";
import {updateWabaDetails} from "../../api/updateWabaDetails";

export const twilioEmbeddedSignupInfoListener = ({
    loadWaba, selectedDomain, onCompleteMetaOnboarding, onFailMetaOnboarding, setIsLoading, setIsInMetaEmbedded
}: {
    loadWaba:() => void,
    selectedDomain?: string,
    onCompleteMetaOnboarding?: () => void,
    onFailMetaOnboarding?: () => void,
    setIsLoading: (newVal: boolean) => void;
    setIsInMetaEmbedded: (newVal: boolean) => void;
}) => async (event: any) => {
    console.log("event: ", event.origin);
    if (!event.origin.endsWith('facebook.com')) return;
    try {
        setIsInMetaEmbedded(false);
        setIsLoading(true);
        console.log("event.data: ", event.data);
        const data = JSON.parse(event.data);
        console.log("data: ", data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
            console.log("wa_embedded_signup: ", data.event);
            // if user finishes the Embedded Signup flow
            if (data.event === 'FINISH' || data.event === 'FINISH_ONLY_WABA') {
                const { phone_number_id, waba_id } = data.data;
                if(!selectedDomain) {
                    setIsLoading(false);
                    return;
                }
                const response = await updateWabaDetails(selectedDomain, waba_id, phone_number_id);
                if(response.data.state === 'success') {
                    loadWaba();
                    onCompleteMetaOnboarding && onCompleteMetaOnboarding();
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 3000);
                } else {
                    onFailMetaOnboarding && onFailMetaOnboarding();
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 3000);
                }
                // if user cancels the Embedded Signup flow
            } else if (data.event === 'CANCEL') {
                setIsLoading(false);
                onFailMetaOnboarding && onFailMetaOnboarding();
                const {current_step} = data.data;

                // if user reports an error during the Embedded Signup flow
            } else if (data.event === 'ERROR') {
                setIsLoading(false);
                onFailMetaOnboarding && onFailMetaOnboarding();
                const {error_message} = data.data;
                console.error('error ', error_message);
            } else {
                setIsLoading(false);
            }
        }
    } catch(error) {
        console.log('Non JSON Responses', event.data);
        if(event.data.includes('error')) {
            setIsLoading(false);
            onFailMetaOnboarding && onFailMetaOnboarding();
        }
    }
};

export const directEmbeddedSignupInfoListener = (loadWaba: () => void, selectedDomain?: string) => async (event: any) => {
    if (event.origin !== "https://www.facebook.com") return;
    try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
            if (data.event === 'FINISH' || data.event === 'FINISH_ONLY_WABA') {
                const { waba_id, phone_number_id } = data.data;
                selectedDomain && await createShopWhatsappAccount(selectedDomain, waba_id, phone_number_id);
                loadWaba();
                // console.log("phoneNumberId: ", phone_number_id);
                console.log("waba_id: ", waba_id);
                console.log("shop: ", selectedDomain);
            }
            // if user cancels the Embedded Signup flow
            else {
                const{ current_step } = data.data;
                console.log("user abandoned flow at: ", current_step);
            }
        }
    } catch {
        // Don’t parse info that’s not a JSON
        console.log('Non JSON Response', event.data);
    }
};
